import React from 'react';
import './Header.css';
import NavigationBar from './NavagationBar';
import TopHeader from './TopHeader';

export default function Header() {
    return (
        <>
            <TopHeader></TopHeader>
            <NavigationBar></NavigationBar>
        </>
    )
}